import React, { useState } from 'react';
import { Link as ScrollLink, scroller } from 'react-scroll';
import { useNavigate, useLocation } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Button from '@mui/material/Button';
import useMediaQuery from '@mui/material/useMediaQuery';
import logo from '../../assets/logo.png';
import { useEffect } from 'react';
import './Navbar.css';

const Navbar = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const isMobile = useMediaQuery('(max-width:768px)');
  const navigate = useNavigate();
  const location = useLocation();
  const isContactPage = location.pathname === '/contact';
  const isAboutPage = location.pathname === '/aboutPage';



  const navItems = [
    { label: 'Home', to: 'home' },
    { label: 'About Us', to: 'about' },
    { label: 'Services', to: 'services' },
    { label: 'How It Works', to: 'howitworks' },
    { label: 'Testimonials', to: 'testimonials' },
    { label: 'Contact Us', to: 'contact' }
  ];

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  const handleNavClick = (to) => {
    if (to === 'contact') {
      navigate('/contact');
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' }); // 👈 scroll to top
    } else if (to === 'about') {
      navigate('/aboutPage');
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' }); // 👈 scroll to top
    } else if (isContactPage || isAboutPage) {
      navigate('/');
      setTimeout(() => {
        scroller.scrollTo(to, {
          duration: 800,
          delay: 0,
          smooth: 'easeInOutQuart'
        });
      }, 100); // Delay to ensure HomePage loads
    } else {
      scroller.scrollTo(to, {
        duration: 800,
        delay: 0,
        smooth: 'easeInOutQuart'
      });
    }
  };



  const renderNavItems = () => (
    navItems.map((item) => {
      if (isContactPage || isAboutPage) {
        return (
          <Button
            key={item.to}
            color="inherit"
            className="nav-btn"
            onClick={() => handleNavClick(item.to)}
          >
            {item.label}
          </Button>
        );
      } else {
        return (item.to === 'contact' || item.to === 'about') ? (
          <Button
            key={item.to}
            color="inherit"
            className="nav-btn"
            onClick={() => handleNavClick(item.to)}
          >
            {item.label}
          </Button>
        ) : (
          <ScrollLink
            key={item.to}
            to={item.to}
            smooth={true}
            duration={500}
            offset={-70}
            className="nav-btn"
          >
            {item.label}
          </ScrollLink>
        );
      }
    })
  );



  return (
    <>
      <div className='navbar-container'>

        <Box className="top-strip">
          <div className='contact-info'>
            <h3 className='enail'>
              <a href="mailto:contactus@vedantenterprisesglb.com">
                CONTACTUS@VEDANTENTERPRISESGLB.COM
              </a>
            </h3>
            <div className="card-divider"></div>
            <h3 className='pno'>
              <a href="tel:+918310427583">
                +91 8310427583
              </a>
            </h3>
          </div>
          <div className="company-name">
            <h1 className='vedant'>VEDANT ENTERPRISES</h1>
          </div>
          {/* <Button variant="contained" className="quote-btn">GET QUOTE</Button> */}
        </Box>


        <AppBar
          position="relative"
          elevation={0}
          sx={{ backgroundColor: 'transparent', boxShadow: 'none' }}
          className="navbar">
          <Toolbar className='toolbar'>
            <img className='logo' src={logo} alt="logo" />
            {isMobile ? (
              <>
                <IconButton edge="end" color="inherit" aria-label="menu" onClick={toggleDrawer(true)}>
                  <MenuIcon />
                </IconButton>
                <Drawer className='drawer' anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
                  <Box role="presentation" onClick={toggleDrawer(false)} onKeyDown={toggleDrawer(false)} sx={{ width: 250 }}>
                    <List>
                      {navItems.map((item) => (
                        <ListItem key={item.to} disablePadding>
                          <ListItemButton onClick={() => handleNavClick(item.to)}>
                            <ListItemText primary={item.label} />
                          </ListItemButton>
                        </ListItem>
                      ))}
                    </List>
                  </Box>
                </Drawer>
              </>
            ) : (
              <Box className="nav-links">
                {renderNavItems()}
              </Box>
            )}
          </Toolbar>
        </AppBar>
      </div>
    </>
  );
};

export default Navbar;
